import React from 'react';
import Container from '@/components/ui/Container';
import SectionHeader from '@/components/ui/SectionHeader';
import { IHireAiTable } from '@/components/type/hireUs/hireAiType';

type Props = {
  table: IHireAiTable;
};

const HireAiTable = ({ table }: Props) => {
  const colCount = table.columns.length;
  const lastRow = table.rows.length - 1;

  return (
    <div className="w-full bg-black">
      <Container className="flex flex-col gap-10 pb-20 md:pb-20 lg:pb-[120px]">
        <SectionHeader
          headingText={table.headingText}
          descriptionText={table.descriptionText}
          isSectionDark={true}
          className="mx-auto max-w-[927px]"
        />
        <div className="overflow-x-auto rounded-[14px] bg-gradient-to-r from-[#1769ed] via-[#1443c0] to-[#1a2c91] p-[7px]">
          <div
            className="grid"
            style={{
              gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
              minWidth: colCount > 3 ? '800px' : '640px',
            }}
          >
            {/* Header */}
            {table.columns.map((col, i) => {
              const isFirst = i === 0;
              const isLast = i === colCount - 1;
              return (
                <div
                  key={col}
                  className={`bg-white text-[#080808] ${
                    isFirst
                      ? 'mr-3 overflow-hidden rounded-tl-[14px] rounded-tr-[12px] sm:mr-5'
                      : i === 1
                        ? 'rounded-tl-[14px]'
                        : ''
                  } ${isLast && !isFirst ? 'overflow-hidden rounded-tr-[14px]' : ''}`}
                >
                  <div
                    className={`flex h-[50px] items-center px-3 text-xs font-semibold sm:h-[57px] sm:px-4 sm:text-sm md:px-6 md:text-base ${
                      !isFirst && !isLast ? 'border-r border-[#879be8]' : ''
                    }`}
                  >
                    {col}
                  </div>
                </div>
              );
            })}

            {/* Rows */}
            {table.rows.map((row, index) => {
              const isLastRow = index === lastRow;
              return (
                <div key={row.label} className="contents">
                  <div
                    className={`flex min-h-[55px] items-center bg-white/[0.045] px-3 text-sm font-medium text-white first:mr-3 sm:min-h-[65px] sm:px-4 sm:text-base sm:first:mr-5 md:px-6 ${
                      isLastRow
                        ? 'rounded-bl-[14px] rounded-br-[14px]'
                        : 'border-b border-white/[0.07]'
                    }`}
                  >
                    {row.label}
                  </div>

                  {row.values.map((value, i) => (
                    <div
                      key={i}
                      className={`flex min-h-[55px] items-center border-l border-white/[0.06] bg-black/[0.12] px-3 py-3 text-sm leading-5 text-white sm:min-h-[65px] sm:px-4 sm:text-base md:px-6 ${
                        !isLastRow ? 'border-b border-white/[0.07]' : ''
                      } ${isLastRow && i === 0 ? 'rounded-bl-[14px]' : ''} ${
                        isLastRow && i === row.values.length - 1
                          ? 'rounded-br-[14px]'
                          : ''
                      }`}
                    >
                      {value}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HireAiTable;
